
// Contract Links
export const SAFEGUARD_CONTRACT_BASE_URL = 'https://na3.docusign.net/Member/PowerFormSigning.aspx?PowerFormId=59de9301-b27b-4f04-8bb8-f4e03bd93a6b&env=na3&acct=84e5b83b-b45b-4acf-b36f-c9f8e5c2468d&v=2';

export const REGISTRATION_URL = 'https://sellercentral.amazon.com/gp/on-board/workflow/Registration/login.html?ie=UTF8&passthrough%2Faccount=soa&passthrough%2FsuperSource=OAR&passthrough%2FmarketplaceID=ATVPDKIKX0DER&passthrough%2FsimplifiedLogin=1&productTier=SILVER';

export const CONTACT_US_URL = 'https://www.autos.amazon/contact-us'

export const CONDITIONS_OF_USE_URL = 'https://www.amazon.com/gp/help/customer/display.html/ref=ap_signin_notification_condition_of_use?nodeId=GLSBYFE9MGKKQXXM&ie=UTF8';

export const PRIVACY_NOTICE_URL = 'https://www.amazon.com/gp/help/customer/display.html/ref=ap_signin_notification_privacy_notice?nodeId=GX7NJQ4ZB8MHFRNJ&ie=UTF8';

export const NEW_TAB = '_blank';
